// extracted by mini-css-extract-plugin
export var animation = "Concept-module--animation--a45aa";
export var animationContainer = "Concept-module--animation-container--a9168";
export var root = "Concept-module--root--f5eac";
export var typographies = "Concept-module--typographies--4bb0b";